import React from 'react';
import { Protocol } from '../data/protocols';
import { useLanguage } from '../i18n/LanguageContext';

interface SafetyScreenProps {
  protocol: Protocol;
  onContinue: () => void;
  onCancel: () => void;
}

const SafetyScreen: React.FC<SafetyScreenProps> = ({ protocol, onContinue, onCancel }) => {
  const { language, t } = useLanguage();
  const pick = (b: { no: string; en: string }) => (language === 'en' ? b.en : b.no);

  return (
    <div className="text-left">
      <div className="flex items-center gap-2 mb-3">
        <svg className="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01M5.07 19h13.86a2 2 0 001.74-3L13.74 4a2 2 0 00-3.48 0L3.34 16a2 2 0 001.73 3z"
          />
        </svg>
        <h2 className="text-2xl font-bold">{t('protocols.safetyTitle')}</h2>
      </div>
      <p className="text-stone-700 mb-6">{protocol.safety ? pick(protocol.safety) : ''}</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={onContinue}
          className="flex-1 px-6 py-3 text-base font-medium text-white bg-accent rounded-full hover:bg-accent-dark"
        >
          {t('protocols.understandContinue')}
        </button>
        <button
          onClick={onCancel}
          className="flex-1 px-6 py-3 text-base font-medium text-stone-600 bg-white border border-stone-300 rounded-full hover:bg-stone-50"
        >
          {t('protocols.back')}
        </button>
      </div>
    </div>
  );
};

export default SafetyScreen;
